export default __webpack_public_path__ + "static/media/STLCertificateReg74.05fb51ac.pdf";